import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ZoneService {
	private zoneNumberSubject: BehaviorSubject<string>;
	private zoneLocationSubject: BehaviorSubject<string>;
	private readonly zoneNumberLocalStorageKey = 'zoneNumber';

	constructor() {
		this.zoneNumberSubject = new BehaviorSubject<string>(localStorage.getItem(this.zoneNumberLocalStorageKey) ?? null);
		this.zoneLocationSubject = new BehaviorSubject<string>(null);
	}

	setZoneNumber(zoneNumber: string) {
		this.zoneNumberSubject.next(zoneNumber);
		localStorage.setItem(this.zoneNumberLocalStorageKey, zoneNumber);
	}

	getZoneNumber(): string {
		return this.zoneNumberSubject.value || '';
	}

	clearZoneNumber() {
		this.zoneNumberSubject.next(null);
	}

	setZoneLocation(zoneLocation: string) {
		this.zoneLocationSubject.next(zoneLocation);
	}

	getZoneLocation(): string {
		return this.zoneLocationSubject.value || '';
	}

	clearZoneLocation() {
		this.zoneLocationSubject.next(null);
	}
}
